import React from "react";
import { AlertCircle } from "lucide-react";
import { Button, ButtonVariant } from "@/shared/ui/Button";

interface ErrorStateProps {
  error: string;
  onRetry?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <AlertCircle className="h-8 w-8 text-destructive mb-2" />
      <p className="text-destructive mb-4">{error}</p>
      {onRetry && (
        <Button
          onClick={onRetry}
          variant={ButtonVariant.Outline}
          data-testid="retry-button"
        >
          Try Again
        </Button>
      )}
    </div>
  );
};
